import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import DropdownSelect from '../../components/ProposalGenerator/DropdownSelect';

const portsList = [{ label: '8', value: '8' }, { label: '24', value: '24' }];

const GrandStream = ({ showUrl, selectedItems }) => {
  const [macAdress, setMacAddress] = useState('');
  const [isShowUrl, setIsShowUrl] = useState(false);
  const [selectedItem, setSelectedItem] = useState(portsList[0]);
  const dispatch = useDispatch();

  const handleSearch = () => {
    if (macAdress?.length > 0) {
      setIsShowUrl(true);
    }
    setMacAddress('');
  };

  const handleInput = e => {
    setMacAddress(e?.target?.value);
    setIsShowUrl(false);
  };

  useMemo(() => {
    selectedItems(macAdress, selectedItem.value);
  }, [macAdress, selectedItem]);
  const onDropSelect = e => {
    setSelectedItem(e);
  };

  return (
    <div>
      {!showUrl && (
        <>
          <Row>
            <Col md={4}>
              <Label for="name">MAC Address:</Label>
            </Col>
            <Col md={6}>
              <Input
                placeholder="Enter MAC address"
                required
                type="text"
                value={macAdress}
                onChange={handleInput}
                name="epikCustomerId"
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label for="name">Number of Ports:</Label>
            </Col>
            <Col md={6}>
              <DropdownSelect
                options={portsList}
                selectedOption={selectedItem}
                onSelect={onDropSelect}
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default GrandStream;
